import './rewards.css';
import '@fontsource/open-sauce-one';
import Coupon from './component/Coupon/coupon';
import SpinTheWheel from './component/SpinTheWheel/spinwheel';
import Card from './component/Card/Card';
import React, { useEffect, useState } from 'react';
import Winnings from './component/Winnings/Winnings';
import {useHistory, withRouter} from 'react-router-dom';
import BottomDrawer from './component/Winnings/BottomDrawer';
import baseURLGlobal from '../../utils/util';
import { SOURCE_HOME, } from './util';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper';
import Lottie from 'react-lottie';
import studentSpinAnimation from './assets/gyan-live-student.json';
import studentSpinAnimationImage from './assets/student-gyan-live-ticker.json';
import { cosmosTrackService } from '../../cosmosTracking/cosmosTrackService';
import {Spin_the_wheeler} from '../../cosmosTracking/cosmosEvents';
import { directDeepLink } from '../../tutor/webviewreboot/util';

function Rewards() {
	const baseUrl = baseURLGlobal;
	const [data, setData] = useState({});
	const [rotating, setRotating] = useState(false);
	const [openModals, setOpenModals] = useState(false);
	const [modalsData, setModalsData] = useState();
	const [winnings, setWinnings] = useState(0);
	const [promoTypeId, setPromoTypeId] = useState('');
	const [showBottomDrawer, setShowBottomDrawer] = useState(false);
	const [spinnerModal, setSpinnerModal] = useState(false);
	const [drawerContent, setDrawerContent] = useState({});

	const spinAnimation = {
		loop: true,
		autoplay: true,
		animationData: studentSpinAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	const spinAnimationImages = {
		loop: true,
		autoplay: true,
		animationData: studentSpinAnimationImage,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	let url = new URL(window.location.href);
	let token = url.searchParams.get('token');

	const handleDrawerOpen = (drawerContent) => {
		setDrawerContent(drawerContent);
		setShowBottomDrawer(true);
	};
	const handleDrawerClose = () => {
		setDrawerContent({});
		setShowBottomDrawer(false);
	};

	const handleModals = () => {
		// setOpenModals(true);
		setRotating(true);
		setTimeout(() => {
			setOpenModals(true);
		}, 5000);
	};

	const _postSpinHandler = async () => {
		setRotating(false); // this is useless though for now
		let data = await postAwards();
	};

	const postAwards = async () => {
		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('x-access-token', token);
		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: JSON.stringify({ promoTypeId }),
		};

		return await fetch(
			`${baseUrl}/v2/course/campaign/student/award/redeemVoucher`, requestOptions
		)
			.then((response) => response.json())
			.then((results) => setModalsData(results.data))
			.catch((error) => {
				console.log('error', error);
				return null;
			});
	};

	const getAwards = () => {
		let myHeaders = new Headers();
		myHeaders.append('api-version', '25');
		myHeaders.append('x-access-token', token);
		let requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow',
		};
		fetch(`${baseUrl}/v2/course/campaign/student/home`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				setData(result);
				let winnerobj = result?.data?.userAwards?.scratchCards.find(
					(res) => res?.winner
				);
				setPromoTypeId(winnerobj?.id);
			})
			.catch((error) => console.log('error', error));
	};

	const handleSpinBtn = function (){
		let DeepLink = {
			screen: '',
			paramOne: '',
			paramTwo: '',
			paramTracking: 'StudentSideSpinWheelClickTracking',
			paramThree: '',
			paramSource: '',
		};
		handleModals();
		window?.mobile?.onDeeplinkExecutedV2(
			JSON.stringify(DeepLink)
		);
		directDeepLink(DeepLink, SOURCE_HOME);
	}

	const handleCouponModal = function (){
		setTimeout(() => {
			setOpenModals(false);
			setSpinnerModal(false);
		}, 2000);
		setWinnings(winnings + 1);
	}

	useEffect(() => {
		getAwards();
	}, [winnings]);

	return (
		<div className="layoutBackground" id="Background">
			<img className="page-top-img" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/top-img-gyan-live.png" alt="top-img"/>
			<div className="page-voucher-group">
				<Lottie options={spinAnimationImages}/>
			</div>
			<div className="layoutSlider">
				<h2>Purchase Course & win Amazing Vouchers</h2>
				<Swiper className="layoutSwiper"
						pagination={{clickable: true}}
						modules={[Pagination]} slidesPerView={1.1}>
					{data?.data?.courses?.map((item, index)=>{
						return(
							<SwiperSlide key={item.id || index}>
								<Card data={item}/>
							</SwiperSlide>
						)
					})}
				</Swiper>
			</div>

			<div className="layoutReward">
				<Lottie options={spinAnimation}/>
				<div className="rewardSpinBtnGroup">
					<button className="rewardSpinBtn"
							onClick={() => {cosmosTrackService(Spin_the_wheeler);
								setSpinnerModal(true);}}>Spin Now
					</button>
				</div>
			</div>
			{spinnerModal &&
				<div className="spinModalOverlay">
					<div className="overlayClose" onClick={() => {setSpinnerModal(false)}}>
						<img src="https://cdn-wl-assets.classplus.co/production/single/learn/c07048ce-6b73-44ce-b8ea-7cc5cba0c415.png" alt="close" width={22}/>
					</div>
					<div className="overlayContent">
						<SpinTheWheel
							prizeList={data?.data?.userAwards?.scratchCards}
							rotating={rotating}
							postSpinHandler={_postSpinHandler}
						/>
						{data?.data?.userAwards?.scratch ?(
								<button className="overlayActionBtn" onClick={handleSpinBtn}>Tap to Spin</button> ):
							(
								<>
									<button className="overlayActionBtn" disabled={true}>Tap to Spin</button>
									<p>Purchase a course above ₹3000 to unlock the wheel</p>
								</>
							)
						}
					</div>
				</div>
			}
			{data?.data?.userAwards?.awardsList &&
				<div className="layoutWining">
					<h4>Your Winnings</h4>
					<div className="WinnerCardGroup">
						{data?.data?.userAwards?.awardsList?.map((item) => (
							item.id === 44 ? null : (
								<Winnings key={item.id} data={item} handleDrawerOpen={handleDrawerOpen} />
							)
						))}
					</div>
				</div>
			}

			{openModals &&
				<div className="couponModalOverlay">
					<div className="overlayClose" onClick={handleCouponModal}>
						<img src="https://cdn-wl-assets.classplus.co/production/single/learn/c07048ce-6b73-44ce-b8ea-7cc5cba0c415.png" alt="close" width={22}/>
					</div>
					<div className="overlayContent">
						<h4>Congratulations!!</h4>
						<Coupon datas={modalsData} />
						<p>Copy the Coupon code to redeem</p>
					</div>
				</div>
			}
			{showBottomDrawer && (
				<BottomDrawer
					drawerContent={drawerContent}
					closeDrawer={handleDrawerClose}
				/>
			)}
		</div>
	);
}

export default withRouter(Rewards);
